import useBbbMissBudget from './useMissBudget'

export const api = {
  bbbMissBudget: useBbbMissBudget,
}
